module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-HeavyItalic.508c37d4.otf";